"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _textInput = _interopRequireDefault(require("@zipwhip/zipkit/dist/components/inputs/text-input"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var CreditCardInput = function CreditCardInput(_ref) {
  var className = _ref.className,
      value = _ref.value,
      rest = _objectWithoutProperties(_ref, ["className", "value"]);

  var getCardType = function getCardType(number) {
    var ccType = '';

    if (!number) {
      return '';
    }

    var checkDigit = parseInt(number[0].concat(number[1]));
    var visaRegex = /4[0-9]/;
    var mcRegex = /5[1-5]/;
    var discRegex = /6[0,2,4,5]/;
    var amexRegex = /3[4,7]/;

    if (visaRegex.test(checkDigit)) {
      ccType = 'Visa';
    } else if (mcRegex.test(checkDigit)) {
      ccType = 'MasterCard';
    } else if (discRegex.test(checkDigit)) {
      ccType = 'Discover';
    } else if (amexRegex.test(checkDigit)) {
      ccType = 'AmericanExpress';
    } else {
      ccType = 'Invalid';
    }

    return ccType;
  };

  var handleNumberFormat = function handleNumberFormat(value) {
    // supports Amex, Master Card, Visa, and Discover
    if (value) {
      var ccValue = value.replace(/\s+/g, '').replace(/[^0-9]/gi, '');
      var formatted = '';
      var cardType = getCardType(value); // all support card types have a 4 digit first block

      if (cardType === 'AmericanExpress') {
        formatted = "".concat(ccValue.substring(0, 4), " ").concat(ccValue.substring(4, 10), " ").concat(ccValue.substring(10)).trim();
        return formatted;
      }

      formatted = "".concat(ccValue.substring(0, 4), " ").concat(ccValue.substring(4, 8), " ").concat(ccValue.substring(8, 12), " ").concat(ccValue.substring(12)).trim();
      return formatted;
    }

    return '';
  };

  return _react.default.createElement(_textInput.default, _extends({
    className: className,
    maxLength: "19",
    placeholder: "1234 1234 1234 1234",
    value: handleNumberFormat(value),
    testid: "CREDIT_CARD_INPUT",
    type: "tel"
  }, rest));
};

var _default = CreditCardInput;
exports.default = _default;